import React, { useEffect } from "react";
import { Form, Col, Button, FormGroup, Table, Label, Input } from "reactstrap";
import StatusFormTableTd from "./status-form-table-td";
import PRInput from "../common/PRInput";

export default function StatusFormResult(props) {
  let disabledVal = true;

  useEffect(() => {
  }, [props.srFieldsVALUE,props.state.values]);

  return (
    <>
      <Form
        onSubmit={(evt) => {
          evt.preventDefault();
          props.clickNewSearch(evt);
        }}
      >
        <Col>
          <PRInput
            elem={props.state.SRnumber}
            validate={props.onchange}
            translate={props.translate}
            lang={props.lang}
            disabled={disabledVal}
          />

       
          {props.srFieldsVALUE
            ? props.srFieldsVALUE.map((a) => (
              <div>
                <Label className={a.fontWeight ? "label-font" : ""}>
                  {props.translate(props.lang, a.label)}{" "}
                </Label>
                <Input
                  key={props.Guid()}
                  name={a.name}
                  value={a.value}
                  translate={props.translate}
                  lang={props.lang}
                  disabled={true}
                  required={false}
                /></div>
            )
            )
            : ""}

          {props.state.comments.length && props.state.comments.some(a => a.activityType == 1) ? (
            <Table responsive>
              <thead>
                <tr>
                  Comments
                </tr>
              </thead>
              <tbody>
                {props.state.comments.map((a) => (
                  (a.activityType == 1) ?
                    <tr key={props.Guid()}>
                      <td key={props.Guid()} dangerouslySetInnerHTML={{__html: a.comments}}></td>
                    </tr> : ''
                ))}
              </tbody>
            </Table>)
            : ""}
          {(props.state.values.length) ? (props.translate(props.lang, "WorkOrderInfoLabel")) : ""}

          {props.state.header.length ? (

            <Table responsive>
              <thead>
                <tr>
                  {props.state.header.map((a) => (
                      <th key={props.Guid()}>{props.translate(props.lang, a.label)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.state.values.map((a) => (
                  <tr key={props.Guid()}>
                    <StatusFormTableTd value={a} Guid={props.Guid} />
                  </tr>
                ))}
              </tbody>
            </Table>) : ""}


          {props.state.comments.length && props.state.comments.some(a => a.activityType == 2) ? (
            <Table responsive>
              <thead>
                <tr>
                  Comments
                </tr>
              </thead>
              <tbody>
                {props.state.comments.map((a) => (
                  (a.activityType == 2) ?
                    <tr key={props.Guid()}>
                      <td key={props.Guid()} dangerouslySetInnerHTML={{__html: a.comments}}></td>
                    </tr> : ''
                ))}
              </tbody>
            </Table>)
            : ""}


          <FormGroup>
            <Button
              color="info"
              onClick={(e) => {
                props.clickNewSearch(e);
              }}
            >
              {props.translate(props.lang, "SRbuttonNewSearchLabel")}
            </Button>
          </FormGroup>
        </Col>
      </Form>
    </>
  );
}
